import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type MoreHorizProps = IconComponentBaseProps;

export const MoreHoriz = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: MoreHorizProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_9199_111221"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_9199_111221)">
        <path
          d="M6.23074 13.5C5.81824 13.5 5.46516 13.3531 5.17149 13.0592C4.87766 12.7656 4.73074 12.4125 4.73074 12C4.73074 11.5875 4.87766 11.2344 5.17149 10.9408C5.46516 10.6469 5.81824 10.5 6.23074 10.5C6.64324 10.5 6.99641 10.6469 7.29024 10.9408C7.58391 11.2344 7.73074 11.5875 7.73074 12C7.73074 12.4125 7.58391 12.7656 7.29024 13.0592C6.99641 13.3531 6.64324 13.5 6.23074 13.5ZM12 13.5C11.5875 13.5 11.2344 13.3531 10.9407 13.0592C10.6469 12.7656 10.5 12.4125 10.5 12C10.5 11.5875 10.6469 11.2344 10.9407 10.9408C11.2344 10.6469 11.5875 10.5 12 10.5C12.4125 10.5 12.7656 10.6469 13.0592 10.9408C13.3531 11.2344 13.5 11.5875 13.5 12C13.5 12.4125 13.3531 12.7656 13.0592 13.0592C12.7656 13.3531 12.4125 13.5 12 13.5ZM17.7692 13.5C17.3567 13.5 17.0036 13.3531 16.7097 13.0592C16.4161 12.7656 16.2692 12.4125 16.2692 12C16.2692 11.5875 16.4161 11.2344 16.7097 10.9408C17.0036 10.6469 17.3567 10.5 17.7692 10.5C18.1817 10.5 18.5348 10.6469 18.8285 10.9408C19.1223 11.2344 19.2692 11.5875 19.2692 12C19.2692 12.4125 19.1223 12.7656 18.8285 13.0592C18.5348 13.3531 18.1817 13.5 17.7692 13.5Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
